import { JSX, SVGProps } from 'react';

export const Sanity = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={20} viewBox="0 0 15 19" {...props}>
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#f03e2f',
        fillOpacity: 1,
      }}
      d="M1.602 2.492c0 2.535 1.64 4.047 4.921 4.844l3.477.77c3.11.683 5 2.374 5 5.136a5.1 5.1 0 0 1-1.16 3.324c0-2.753-1.488-4.242-5.082-5.136l-3.414-.742C2.609 10.09.5 8.699.5 5.699a5.05 5.05 0 0 1 1.102-3.207"
    />
    <path
      style={{
        stroke: 'none',
        fillRule: 'nonzero',
        fill: '#f68b82',
        fillOpacity: 1,
      }}
      d="M11.703 12.566c1.485.907 2.133 2.176 2.133 3.996-1.227 1.504-3.383 2.348-5.918 2.348-4.27 0-7.254-2.008-7.918-5.496h4.098c.527 1.602 1.925 2.344 3.789 2.344 2.277 0 3.789-1.16 3.82-3.2M3.734 6.254a4.25 4.25 0 0 1-1.609-1.602 4.04 4.04 0 0 1-.523-2.16C2.789 1 4.848.09 7.359.09c4.348 0 6.864 2.195 7.485 5.285h-3.942C10.47 4.156 9.38 3.207 7.395 3.207c-2.122 0-3.57 1.18-3.653 3.047"
    />
  </svg>
);
